import { Play, Pause, Trash2 } from "lucide-react";

// Bulk action configuration
export const BULK_ACTIONS = [
  { 
    label: "Activate", 
    action: "activate", 
    icon: Play 
  },
  { 
    label: "Pause", 
    action: "pause", 
    icon: Pause 
  },
  { 
    label: "Delete", 
    action: "delete", 
    icon: Trash2 
  }
];

// Filter options
export const STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "draft", label: "Draft" },
  { value: "paused", label: "Paused" },
  { value: "closed", label: "Closed" },
  { value: "filled", label: "Filled" }
];

export const PRIORITY_FILTER_OPTIONS = [
  { value: "all", label: "All Priority" },
  { value: "urgent", label: "Urgent" },
  { value: "high", label: "High" },
  { value: "normal", label: "Normal" },
  { value: "low", label: "Low" }
];

// Table configuration
export const TABLE_HEADERS = [
  { key: "select", label: "", width: "w-12" },
  { key: "title", label: "Job Title", width: "min-w-[250px]" },
  { key: "company", label: "Company", width: "min-w-[150px]" },
  { key: "status", label: "Status", width: "min-w-[100px]" },
  { key: "priority", label: "Priority", width: "min-w-[100px]" },
  { key: "applications", label: "Applications", width: "min-w-[100px]" },
  { key: "recruiter", label: "Assigned Recruiter", width: "min-w-[140px]" },
  { key: "actions", label: "Actions", width: "min-w-[100px]" }
];

// Common CSS classes
export const COMMON_CLASSES = {
  card: "border-0 shadow-sm",
  button: {
    primary: "bg-orange-500 hover:bg-orange-600 text-white space-grotesk font-medium",
    ghost: "variant-ghost size-sm h-8 px-2 text-gray-600 hover:bg-gray-100",
    outline: "variant-outline space-grotesk"
  },
  text: {
    heading: "text-2xl lg:text-3xl font-bold text-gray-900 space-grotesk",
    subheading: "text-gray-600 text-sm lg:text-base",
    label: "font-medium",
    input: "space-grotesk",
    small: "text-xs text-gray-500 font-medium uppercase tracking-wide",
    kpi: "text-3xl font-bold text-gray-900"
  },
  layout: {
    container: "min-h-screen bg-gray-50",
    content: "lg:ml-56 xl:ml-64 p-4 lg:p-8 xl:p-10 pt-20 lg:pt-8 xl:pt-10",
    grid: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 xl:gap-8 mb-6 lg:mb-8 xl:mb-10"
  }
};
